






















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module
---------------------------------------- */

import anime from 'animejs';

/* ----------------------------------------
     Icons
 ---------------------------------------- */

import ArrowLeftIcon from '@icon/ArrowLeftIcon.vue';
import ArrowRightIcon from '@icon/ArrowRightIcon.vue';
import ArrowDownIcon from '@icon/ArrowDownIcon.vue';
import ContactIcon from '@icon/ContactIcon.vue';
import PhoneIcon from '@icon/PhoneIcon.vue';
import ViewIcon from '@icon/ViewIcon.vue';

/* ----------------------------------------
     Helpers
 ---------------------------------------- */

import * as dom from '@util/dom';

/* ----------------------------------------
    JS Module
---------------------------------------- */

import { MouseData } from '@js/module/Mouse';

/* ----------------------------------------
     Helpers
 ---------------------------------------- */

import * as dom from '@util/dom';
import PhoneIcon from "../icons/PhoneIcon";

/* ----------------------------------------
    Transitions Mouse Cursor
---------------------------------------- */

const changeColor = (el, color) => {
    return new Promise((resolve) => {
        anime({
            targets: el,
            background: color,
            scale: () => color != '#FFB3BD' ? 1 : 1.3,
            opacity: [0, 1],
            duration: 400,
            easing: 'easeInOutQuad',
            complete: () => resolve()
        });
    });
};

/* ----------------------------------------
    Transitions Mouse Follow
---------------------------------------- */

let animating = false;
let currentType;

const fadeIn = (el, type, duration = 250, delay = 0) => {
    if(animating) return;

    const svg = el.querySelector('#' + type);

    return new Promise((resolve) => {
        anime({
            targets: el,
            scale: [1.15, 1],
            opacity: [0, 1],
            duration: duration,
            delay: delay,
            easing: 'easeInSine',
            begin: () => {
                if(type === 'view') el.classList.add('mouse__view--large');
            },
            complete: () => {
                resolve()
            }
        });

        dom.style(svg, {
            top: '50%',
            left: '50%',
            transform: `translate(-50%, -50%)`
        });
    });
};

const fadeOut = (el, type, duration = 150, delay = 0) => {
    const svg = el.querySelector('#' + type);

    return new Promise((resolve) => {
        anime({
            targets: el,
            scale: [1, 1.15],
            opacity: [1, 0],
            duration: duration,
            delay: delay,
            easing: 'easeOutSine',
            complete: () => {
                if(type === 'view') el.classList.remove('mouse__view--large');
                animating = false;
                resolve()
            }
        });

        dom.style(svg, {
            top: '-100%',
            left: '-100%',
            transform: `translate(0%, 0%)`
        });
    });
};

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        PhoneIcon,
        ArrowLeftIcon,
        ArrowRightIcon,
        ArrowDownIcon,
        ContactIcon,
        ViewIcon
    },

    mounted() {
        const mouse = new MouseData();

        const mouseEl = document.querySelector('.mouse');
        const cursor = mouseEl.querySelector('.mouse__dot');
        const follow = mouseEl.querySelector('.mouse__view');
        const text = follow.querySelector('.mouse__text');

        const changeMouse = (bool, type) => {
            const home = this.$route.name === 'home' && type === 'back';
            currentType === 'color' && !bool && !home ? changeColor(cursor, '#341D88') : !bool && currentType && !home && fadeOut(follow, currentType);
            type === 'color' && bool && !home ? changeColor(cursor, '#FFB3BD') : bool && !home && fadeIn(follow, type);
            if (type !== 'empty') currentType = type;
        };

        let xPos = 0,
            yPos = 0;

        let xPosFollow = 0,
            yPosFollow = 0;

        const calcMouse = () => {
            xPos += Math.round((mouse.data.x - xPos - (mouse.data.ax * 5)) * 0.35);
            yPos += Math.round((mouse.data.y - yPos - (mouse.data.ay * 5)) * 0.35);

            cursor.style.left = dom.unit(xPos - cursor.offsetWidth / 2);
            cursor.style.top = dom.unit(yPos - cursor.offsetWidth / 2);

            xPosFollow += Math.round((mouse.data.x - xPosFollow - (mouse.data.ax * 5)) * 0.075);
            yPosFollow += Math.round((mouse.data.y - yPosFollow - (mouse.data.ay * 5)) * 0.075);

            follow.style.left = dom.unit(xPosFollow - follow.offsetWidth / 2);
            follow.style.top = dom.unit(yPosFollow - follow.offsetHeight / 2);

            mouse.data.hover(changeMouse);
        };

        const animate = () => {
            calcMouse();
            window.requestAnimationFrame(animate);
        };

        animate();
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Mouse extends Vue {}

